import { render } from "./createReserveTypesComponent.vue?vue&type=template&id=3bc3d3e2"
import script from "./createReserveTypesComponent.vue?vue&type=script&lang=js"
export * from "./createReserveTypesComponent.vue?vue&type=script&lang=js"

import "./createReserveTypesComponent.vue?vue&type=style&index=0&id=3bc3d3e2&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__